import {useMutation} from "@tanstack/react-query";

import {persistSessionStoreSync} from "@/src/modules/auth/store/session";
import {errorHandler} from "@/src/modules/core/lib";

import {impersonationService} from "../services/impersonation";

export default function useEndImpersonation() {
  return useMutation({
    mutationFn: () => impersonationService.end(),
    onSuccess: () => {
      persistSessionStoreSync();
      // Full reload restores admin bearer, /me, nav, and clears target-user query cache.
      window.location.reload();
    },
    onError: errorHandler,
  });
}